import { useState } from 'react';
import PropTypes from 'prop-types';
import { FlexTable } from '@evertrue/sdk';

/**
 * Generic FlexTable wrapper used by all three cadence list tabs.
 * Consolidates shared FlexTable config (selection, pagination, sorting, toolbar).
 * Tab-specific differences (columns, toggleable columns, visibility, empty state) are passed as props.
 */
const CadenceFlexTable = ({
  tableKey,
  columns,
  data = [],
  loading = false,
  onSelectionChange,
  toggleableColumns = [],
  columnVisibilityModel = {},
  showQuickFilter = true,
  emptyStateMessage = 'No items found',
  emptyStateIcon,
}) => {
  const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });

  const handleRowSelectionChange = (newModel) => {
    setRowSelectionModel(newModel);
    const selectedIds = Array.from(newModel.ids || []);
    const selectedItems = data.filter((row) => selectedIds.includes(row.id));
    onSelectionChange(selectedItems);
  };

  return (
    <FlexTable
      tableKey={tableKey}
      columns={columns}
      rows={data}
      loading={loading}
      checkboxSelection
      rowSelection
      disableRowSelectionOnClick
      rowSelectionModel={rowSelectionModel}
      onRowSelectionModelChange={handleRowSelectionChange}
      showToolbar
      disableColumnMenu
      showColumnVerticalBorder={false}
      sortingMode="client"
      sortingOrder={['asc', 'desc']}
      paginationMode="client"
      pageSizeOptions={[10, 25, 50, 100]}
      slotProps={{
        columnsManagement: {
          getTogglableColumns: () => toggleableColumns,
        },
        toolbar: {
          showExport: false,
          showQuickFilter,
        },
      }}
      initialState={{
        pagination: { paginationModel: { page: 0, pageSize: 25 } },
        sorting: { sortModel: [{ field: 'createdDate', sort: 'desc' }] },
        columns: { columnVisibilityModel },
      }}
      getRowHeight={() => 'auto'}
      emptyStateMessage={emptyStateMessage}
      emptyStateIcon={emptyStateIcon}
    />
  );
};

CadenceFlexTable.propTypes = {
  tableKey: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  loading: PropTypes.bool,
  onSelectionChange: PropTypes.func.isRequired,
  toggleableColumns: PropTypes.arrayOf(PropTypes.string),
  columnVisibilityModel: PropTypes.object,
  showQuickFilter: PropTypes.bool,
  emptyStateMessage: PropTypes.string,
  emptyStateIcon: PropTypes.node,
};

export default CadenceFlexTable;
